<template>
  <div>
    <van-row class="text-c m-b-10">
      <van-col span="6" @click="CourseConsultation"
        ><van-image
          round
          width="2.4rem"
          height="2.4rem"
          :src="courseConsultation"
        />
        <p class="f-s-7 text-c">课程咨询</p></van-col
      >
      <van-col span="6" @click="goLiveList">
        <van-image round width="2.4rem" height="2.4rem" :src="liveCourse" />
        <p class="f-s-7 text-c">直播课程</p>
      </van-col>
      <van-col span="6" @click="welfare">
        <van-image
          round
          width="2.4rem"
          height="2.4rem"
          :src="informationWelfare"
        />
        <p class="f-s-7 text-c">资料福利</p>
      </van-col>
      <van-col span="6" @click="BIMselect">
        <van-image
          round
          width="2.4rem"
          height="2.4rem"
          :src="courseSelection"
        />
        <p class="f-s-7 text-c">BIM选课</p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      courseConsultation: require("@/assets/imgs/home/kechengzixun.png"),
      liveCourse: require("@/assets/imgs/home/liveCourse.png"),
      informationWelfare: require("@/assets/imgs/home/informationWelfare.png"),
      courseSelection: require("@/assets/imgs/home/courseSelection.png"),
    };
  },
  methods: {
    goLiveList() {
      this.$store.commit("Live/editGoLiveNum");
      this.$router.push("/liveList");
    },
    // 课程咨询
    CourseConsultation() {
      window.location.href = "https://url.cn/wOipY03P?_type=wpa&qidian=true";
    },
    // 资料福利
    welfare() {
      this.$store.commit("Live/editGoLiveNum");
      this.$router.push({
        path: "/liveList",
        query: {
          BIMData: true,
        },
      });
    },
    // BIM选课
    BIMselect() {
      this.$router.push({
        path: "/classification",
      });
    },
    notOpen() {
      alert("功能暂未开放");
    },
  },
};
</script>

<style scoped></style>
